const ORDER_ID_FIELDS = new Set(['id', 'orderId', 'closeOrderId', 'positionId', 'execId']);

/** Preserve numeric order IDs before JSON.parse can round integers above 2^53. */
export const parseOrderResponse = (data: unknown): unknown => {
  if (typeof data !== 'string' || !data.trim()) return data;

  // Consume complete JSON strings too, so text inside a string is never rewritten.
  const preserved = data.replace(
    /("(?:\\.|[^"\\])*")(\s*:\s*)(-?\d+)(?=\s*[,}])|"(?:\\.|[^"\\])*"/g,
    (token, key, separator, integer) =>
      key && ORDER_ID_FIELDS.has(JSON.parse(key)) ? `${key}${separator}"${integer}"` : token,
  );
  return JSON.parse(preserved);
};
